/**
 * Lakū — route footer newsletter signups into the Klaviyo Welcome List
 * so they trigger the welcome flow (LAKU10 email), same as the popup.
 * Config comes from window.lakuConfig ({ klaviyoPublicKey, welcomeListId }).
 * Also exposes window.lakuSubscribeWelcome(email) for the skin quiz to reuse.
 */
(function () {
  /* Subscribe an email to the Klaviyo Welcome List. Resolves true only when
   * Klaviyo accepted it.
   *
   * The `profile` object here carries ONLY the email. It used to also carry
   *   subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
   * and Klaviyo rejected every one of those calls with
   *   400 "'subscriptions' is not a valid field for the resource 'profile'"
   * Consent is granted by this endpoint itself, so stating it in the profile is
   * both unnecessary and fatal. Verified 2026-08-25 against a throwaway list:
   * the corrected body returns 202 and the profile lands with
   * consent=SUBSCRIBED, method=API.
   *
   * `custom_source` is what shows up in Klaviyo as where the signup came from,
   * so a future "did the quiz ever work" question is answerable from the data. */
  function subscribeWelcome(email, source) {
    var cfg = window.lakuConfig || {};
    if (!cfg.klaviyoPublicKey || !cfg.welcomeListId || !email) {
      console.warn('[laku-welcome] not attempted — missing config or email');
      return Promise.resolve(false);
    }
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoPublicKey),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source || 'Website',
              profile: { data: { type: 'profile', attributes: { email: email } } },
            },
            relationships: { list: { data: { type: 'list', id: cfg.welcomeListId } } },
          },
        }),
      }
    )
      .then(function (r) {
        if (r.ok || r.status === 202) return true;
        /* Say what happened. The previous version returned false here and every
         * caller ignored it, so a total failure was indistinguishable from
         * success for months. */
        return r.text().then(function (body) {
          console.error('[laku-welcome] Klaviyo refused the subscription:', r.status, body.slice(0, 300));
          return false;
        });
      })
      .catch(function (e) {
        console.error('[laku-welcome] subscription request failed:', e && e.message);
        return false;
      });
  }
  window.lakuSubscribeWelcome = subscribeWelcome;

  /* Report what actually happened.
   *
   * This used to render the success message unconditionally, from inside a
   * `.then()` that ignored its argument — so a signup that Klaviyo had just
   * rejected was told "check your inbox for your 10% code". A message that
   * asserts an outcome the code did not achieve is worse than no message,
   * because the person stops looking for the problem. */
  function showResult(form, ok) {
    var wrap = form.querySelector('.newsletter-form__field-wrapper') || form;
    var msg = document.createElement('p');
    msg.className = ok
      ? 'newsletter-form__message newsletter-form__message--success form__message'
      : 'newsletter-form__message newsletter-form__message--error form__message';
    msg.setAttribute('role', 'status');
    msg.textContent = ok
      ? "You're in — check your inbox for your 10% code."
      : "Something went wrong signing you up. Please email info@lakucosmetics.com and we'll sort your 10% out.";
    wrap.innerHTML = '';
    wrap.appendChild(msg);
  }

  function initFooterForms() {
    var forms = document.querySelectorAll('form.newsletter-form');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.__lakuWired) return;
        form.__lakuWired = true;
        form.addEventListener('submit', function (ev) {
          var input = form.querySelector('input[type="email"]');
          var email = input && input.value && input.value.trim();
          if (!email) return; // let native "required" validation handle empties
          ev.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if (btn) btn.disabled = true;
          subscribeWelcome(email, 'Footer newsletter').then(function (ok) {
            showResult(form, ok);
            if (!ok && btn) btn.disabled = false;
          });
        });
      })(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterForms);
  } else {
    initFooterForms();
  }
})();
